import { stackOptions } from '@jarvis.oddle/core/tools/promotion'

export const parsePromotion = (p) => ({
  promotionId: p.id,
  variants: (p.selectedItems || []).map((item) => {
    return ({
      variantId: item.itemReference || item.id,
      subitems: [],
      quantity: item.quantity
    })
  })
})

export const getValidPromotions = (nonPromoCodePromotions = [], promoCodePromotions = []) => {
  const unstackablePromo = nonPromoCodePromotions.find(p => p.stackableOption === stackOptions.nonStackable)
  if (unstackablePromo) {
    return [unstackablePromo]
  } else {
    const unstackablePromoCode = promoCodePromotions.find(p => p.stackableOption === stackOptions.nonStackable)
    if (unstackablePromoCode) {
      return [unstackablePromoCode]
    }
  }

  return nonPromoCodePromotions.concat(promoCodePromotions)
}
